import $ from 'jquery';
class Loader {
    constructor (text) {
        this.loadingUIText = text;
        this._loader = document.getElementById('imergoLoader');
    }
    displayLoadingUI() {
        $(this._loader).fadeIn(1);
    }

    hideLoadingUI() {
        $(this._loader).fadeOut(500);
    }
}

export default Loader;
